<script setup lang="ts">
import type { PnUploadFileItem } from "@postnord/web-components";
import { ref, onMounted } from "vue";
import { storeToRefs } from "pinia";
import type { StickerUpload } from "@/types/stickers";

import { userStickers } from "@/stores/stickers";
const stickerStore = userStickers();
const { createCollectionReqestParams } = storeToRefs(stickerStore);

const filesToUpload = ref<PnUploadFileItem[]>([]);
const isError = ref(false);

onMounted(() => {
  const existingStickers = createCollectionReqestParams.value.stickers ?? [];
  if (existingStickers.length > 0) {
    filesToUpload.value = existingStickers.map((sticker) => ({
      uuid: crypto.randomUUID(),
      filename: sticker.filename,
      base64: sticker.base64,
      filesize: 0,
      progress: 0,
      status: "completed" as const,
      contentType: "",
      error: null,
      errorMessage: "",
      file: null as any,
      xhr: null as any,
    }));
  }
});

const resetError = () => {
  isError.value = false;
};

const filesAdded = (e: any) => {
  if (e.detail.length > 0) {
    const errorFiles = e.detail.filter((d: any) => d.error);
    if (errorFiles.length > 0) {
      isError.value = true;
      return;
    } else {
      filesToUpload.value = e.detail;
      pushToRequestParam();
    }
  } else if (e.detail.length === 0) {
    resetError();
    filesToUpload.value = e.detail;
    pushToRequestParam();
  }
};

const pushToRequestParam = () => {
  const stickerUploads: StickerUpload[] = filesToUpload.value.map((file) => ({
    filename: file.filename,
    base64: file.base64,
    categories: [],
    completed: false,
  }));
  stickerStore.populateCreateCollectionRequest(stickerUploads, "stickers");
};
</script>

<template>
  <section>
    <div class="name-desc">
      <h3 class="pn-m">Upload stickers</h3>
      <p class="pn-s width-67">
        Upload the stickers belonging to this collection.
      </p>
      <pn-file-upload
        accept=".svg,.jpg, .png"
        max-size="4mb"
        @filesAdded="filesAdded"
        limit="20"
        :files="filesToUpload"
      ></pn-file-upload>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.name-desc {
  display: flex;
  flex-direction: column;
  padding-left: 32px;
}
.width-67 {
  width: 67%;
}
</style>
